import React from "react";
import {
  Clock,
  Monitor,
  Smartphone,
  Tablet,
  Laptop,
  LogOut,
} from "lucide-react";

function getDeviceIcon(name = "") {
  const n = name.toLowerCase();
  if (
    n.includes("iphone") ||
    n.includes("android") ||
    n.includes("phone") ||
    n.includes("cel")
  ) {
    return <Smartphone size={18} />;
  }
  if (n.includes("ipad") || n.includes("tablet")) {
    return <Tablet size={18} />;
  }
  if (n.includes("macbook") || n.includes("laptop")) {
    return <Laptop size={18} />;
  }
  return <Monitor size={18} />;
}

function formatLocation(ubicacion) {
  if (!ubicacion) return "Ubicación desconocida";
  if (typeof ubicacion === "string") return ubicacion;

  const parts = [ubicacion.city, ubicacion.region, ubicacion.country].filter(
    Boolean,
  );
  return parts.length ? parts.join(", ") : "Ubicación desconocida";
}

function timeAgoEs(date) {
  if (!date) return "—";

  const diffSec = Math.floor((Date.now() - date.getTime()) / 1000);

  if (diffSec < 90) return "Activa ahora";

  const min = Math.floor(diffSec / 60);
  if (min < 60) return `Hace ${min} minuto${min === 1 ? "" : "s"}`;

  const hrs = Math.floor(min / 60);
  if (hrs < 24) return `Hace ${hrs} hora${hrs === 1 ? "" : "s"}`;

  const days = Math.floor(hrs / 24);
  if (days < 7) return `Hace ${days} día${days === 1 ? "" : "s"}`;

  const weeks = Math.floor(days / 7);
  return `Hace ${weeks} semana${weeks === 1 ? "" : "s"}`;
}

export default function Sesiones({
  sessions = [],
  currentId,
  revoke,
  revokeOthers,
  t,
}) {
  return (
    <div className="security-card sessions-card">
      {/* Header con acción a la derecha */}
      <div className="sessions-head">
        <div className="security-card-head sessions-head-left">
          <div className="security-icon security-icon--purple">
            <Clock size={18} />
          </div>

          <div className="security-head-text">
            <div className="security-title">
              {t("security.sessions.title", "Sesiones Activas")}
            </div>
            <div className="security-subtitle">
              {t(
                "security.sessions.desc",
                "Administra tus sesiones en diferentes dispositivos",
              )}
            </div>
          </div>
        </div>

        {sessions.some((s) => s.id !== currentId && s.activo !== false) && (
          <button
            type="button"
            className="sessions-link-danger"
            onClick={revokeOthers}
          >
            {t("security.sessions.closeAll", "Cerrar todas las sesiones")}
          </button>
        )}
      </div>

      <div className="security-divider" />

      <div className="session-list session-list--mock">
        {[...sessions].map((s, index) => {
          const isCurrent = s.id === currentId; // SOLO por id
          const isActive = s.activo !== false;

          const activityText = isCurrent
            ? "Activa ahora"
            : timeAgoEs(s.ultimaActividad);

          return (
            <div
              key={s.id || `session-${index}`}
              className={`session-row ${isCurrent ? "is-current" : ""}`}
            >
              <div className="session-left">
                <div className="session-device-icon">
                  {getDeviceIcon(s.dispositivo)}
                </div>

                <div className="session-text">
                  <div className="session-title-row">
                    <div className="session-name">{s.dispositivo}</div>

                    {isCurrent && <span className="pill-current">Actual</span>}
                    {!isActive && !isCurrent && (
                      <span className="pill-muted">Cerrada</span>
                    )}
                  </div>

                  <div className="session-meta-row">
                    <span className="session-location">
                      {formatLocation(s.ubicacion)}
                    </span>
                    <span className="dot">•</span>
                    <span className="session-last">{activityText}</span>
                  </div>
                </div>
              </div>

              {/* Flecha: solo en otras sesiones activas */}
              {!isCurrent && isActive && (
                <button
                  type="button"
                  className="session-arrow-btn"
                  onClick={() => revoke(s.id)}
                  aria-label="Cerrar sesión"
                  title="Cerrar sesión"
                >
                  <LogOut size={18} />
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
